import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-basic',
    prefixClsl: 'sys-statistics',
  }
  constructor(props) {
    super(props);
    this.state = {
      date: this.getCurrentDate(),
    }
  }
  componentDidMount() {
    const { sysStore: { getCount } } = this.props;
    const y = moment().year();
    const m = moment().month() + 1;
    const d = moment().date();
    getCount({ startDate: `${y}-${m}-1`, endDate: `${y}-${m}-${d}` });
  }
  getCurrentDate = () => {
    const y = moment().year();
    const m = moment().month() + 1;
    const d = moment().date();
    return [moment(`${y}-$[m]-1`, 'YYYY-MM-DD'), moment(`${y}-${m}-${d}`, 'YYYY-MM-DD')];
  }
  onChange = (value) => {
    const { sysStore: { getCount } } = this.props;
    this.setState({ date: value });
    getCount({ startDate: value[0].format('YYYY-MM-DD'), endDate: value[1].format('YYYY-MM-DD') });
  }
  render() {
    const { prefixCls, prefixClsl, sysStore: { pccount, mobilecount } } = this.props;
    const { date } = this.state;
    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label ${prefixClsl}-row-label`}>用户名：</span>
          <span className={`${prefixCls}-row-wrapper`}>
            <RangePicker value={date} onChange={this.onChange} />
          </span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label ${prefixClsl}-row-label`}>PC端总访问量：</span>
          <span className={`${prefixCls}-row-wrapper`}>{pccount}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label ${prefixClsl}-row-label`}>MOBILE端总访问量：</span>
          <span className={`${prefixCls}-row-wrapper`}>{mobilecount}</span>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/statistics/BarChart.js